export const getCorrectRemoteLabel = (rawLabel: string): string => {
  return rawLabel.split("_")[1];
};
